import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const namespace = 'features';
export const keyPrefix = 'detach_department_users';
export const useDetachDepartmentUsersTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Открепить пользователя от подразделения',
    toast_error: 'Не удалось открепить пользователей',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Detach user from department',
    toast_error: 'Failed to detach users',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Desvincular usuário do departamento',
    toast_error: 'Falha ao desvincular usuários',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Desvincular usuario del departamento',
    toast_error: 'No se pudieron desvincular los usuarios',
  },
}) : {}) as Record<string, unknown>;
